import React, { Suspense } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import authorizedLayout from "@/components/AuthorizedLayout";
import invisibleLayout from "./components/InvisibleLayout";
import { history } from "./core/helpers/history";
import CustomBrowserRouter from "./CustomBrowserRouter";
import { Loading } from "@/components/Loading";
const LandingLayout = React.lazy(() => import('./components/LandingLayout/LandingLayout'));

const Processes = React.lazy(() => import("./pages/Processes"));
const Slas = React.lazy(() => import("./pages/Slas"));

const HistoryAllPage = React.lazy(() => import("./pages/HistoryPage"));
const MainPage = React.lazy(() => import("./pages/Landing/MainPage/MainPage"));
const FranchisePage = React.lazy(() => import("./pages/Franchise"));
const TabloPage = React.lazy(() => import("./pages/Tablo/TabloPage/TabloPage"));
const LandingDocuments = React.lazy(() => import("./pages/LandingDocuments"));
const Error404 = React.lazy(() => import("./pages/Error404"));
const Login = React.lazy(() => import("./pages/Login"));
const Reports = React.lazy(() => import("./pages/Reports"));
const StartProcess = React.lazy(() => import("./pages/StartProcess"));
const MyTasks = React.lazy(() => import("./pages/MyTasks"));
const Users = React.lazy(() => import("./pages/Users"));
const Roles = React.lazy(() => import("./pages/Roles"));
const UserProfile = React.lazy(() => import("./pages/Users/UserProfile"));
const TaskList = React.lazy(() => import("./pages/TaskList"));
const Queues = React.lazy(() => import("./pages/Queues"));
const Calendars = React.lazy(() => import("./pages/Calendars"));
const History = React.lazy(() => import("./pages/History"));
const Treasure = React.lazy(() => import("./pages/Treasury"));
const DocumentPage = React.lazy(() => import("./pages/DocumentsPage"));
const CashBalance = React.lazy(() => import("./pages/CashBalance"));
const DepartmentOpen = React.lazy(() => import("./pages/DepartmentOpen"));
const PaymentControlPanel = React.lazy(() => import("./pages/PaymentControlPanel"));
const TestPrintCheck = React.lazy(() => import("./pages/TestPrintCheck"));
const ManagementReports = React.lazy(() => import("./pages/ManagementReports"));
const EmployeesList = React.lazy(() => import("./pages/Employees"));
const QrAuthOtp = React.lazy(() => import("./pages/QrAuthOtp"));
const AcceptAllPage = React.lazy(() => import("./pages/Accepts"));
const Helpdesk = React.lazy(() => import("./pages/Helpdesk"));
const CallCenterRoute = React.lazy(() => import("./pages/CallCenter"));
const Accountant = React.lazy(() => import("./pages/Accountant"));
const Reconciliation = React.lazy(() => import("./pages/Reconciliation"));
const Audit = React.lazy(() => import("./pages/Audit"));

const RoutesComponent = () => (
    <React.StrictMode>
        <CustomBrowserRouter history={history}>
            <Suspense fallback={<Loading />}>
                <Routes>
                    <Route
                        path="login"
                        element={invisibleLayout(Login)}
                        errorElement={<Error404 />}
                    />
                    <Route
                        path="/qr/:sessionId"
                        element={invisibleLayout(QrAuthOtp)}
                        errorElement={<Error404 />}
                    />

                    <Route
                        path="startProcess"
                        element={authorizedLayout(StartProcess)}
                        errorElement={<Error404 />}
                    />
                    <Route
                        path="task/:id/*"
                        element={authorizedLayout(Processes)}
                        errorElement={<Error404 />}
                    />
                    <Route
                        path="mytasks"
                        element={authorizedLayout(MyTasks)}
                        errorElement={<Error404 />}
                    />
                    <Route
                        path="queue"
                        element={authorizedLayout(TaskList)}
                        errorElement={<Error404 />}
                    />
                    <Route
                        path="history/*"
                        element={<History />}
                        errorElement={<Error404 />}
                    />
                    <Route
                        path="reports"
                        element={authorizedLayout(Reports)}
                        errorElement={<Error404 />}
                    />
                    <Route
                        path="profile"
                        element={authorizedLayout(UserProfile)}
                        errorElement={<Error404 />}
                    />
                    <Route path="users/*" element={<Users />} errorElement={<Error404 />} />
                    <Route path="roles/*" element={<Roles />} errorElement={<Error404 />} />
                    <Route
                        path="queues/*"
                        element={<Queues />}
                        errorElement={<Error404 />}
                    />
                    <Route
                        path="calendars/*"
                        element={<Calendars />}
                        errorElement={<Error404 />}
                    />
                    <Route path="slas/*" element={<Slas />} errorElement={<Error404 />} />
                    <Route
                        path="/tablo"
                        element={<TabloPage />}
                        errorElement={<Error404 />}
                    />
                    <Route
                        path="/payment-control"
                        element={authorizedLayout(PaymentControlPanel)}
                        errorElement={<Error404 />}
                    />
                    {window.location.hostname === 'ecash.kz' &&
                        <Route
                            path="/"
                            element={<LandingLayout component={MainPage} />}
                            errorElement={<Error404 />}
                        />
                    }
                    <Route
                        path="documents_license/*"
                        element={<LandingLayout component={LandingDocuments} />}
                        errorElement={<Error404 />}
                    />
                    <Route
                        path="/franchise"
                        element={<LandingLayout component={FranchisePage} />}
                        errorElement={<Error404 />}
                    />
                    <Route
                        path="department-open/*"
                        element={authorizedLayout(DepartmentOpen)}
                        errorElement={<Error404 />}
                    />
                    <Route
                        path="employees/*"
                        element={authorizedLayout(EmployeesList)}
                        errorElement={<Error404 />}
                    />
                    <Route
                        path="treasurer-rates/*"
                        element={authorizedLayout(Treasure)}
                        errorElement={<Error404 />}
                    />
                    <Route
                        path="request-list/*"
                        element={authorizedLayout(HistoryAllPage)}
                        errorElement={<Error404 />}
                    />
                    <Route
                        path="/documents/*"
                        element={authorizedLayout(DocumentPage)}
                        errorElement={<Error404 />}
                    />
                    <Route
                        path="/management-reports/*"
                        element={authorizedLayout(ManagementReports)}
                        errorElement={<Error404 />}
                    />
                    <Route
                        path="/cash-balance/*"
                        element={authorizedLayout(CashBalance)}
                        errorElement={<Error404 />}
                    />
                    <Route
                        path="/accountant/*"
                        element={authorizedLayout(Accountant)}
                        errorElement={<Error404 />}
                    />
                    <Route
                        path="/helpdesk"
                        element={authorizedLayout(Helpdesk)}
                        errorElement={<Error404 />}
                    />
                    <Route
                        path="/testPrintCheck"
                        element={<TestPrintCheck />}
                        errorElement={<Error404 />}
                    />
                    <Route
                        path="/accepts/*"
                        element={authorizedLayout(AcceptAllPage)}
                        errorElement={<Error404 />}
                    />
                    <Route
                        path="/call-center"
                        element={authorizedLayout(CallCenterRoute)}
                        errorElement={<Error404 />}
                    />
                    <Route
                        path="/reconciliation"
                        element={authorizedLayout(Reconciliation)}
                        errorElement={<Error404 />}
                    />
                    <Route
                        path="/audit/*"
                        element={authorizedLayout(Audit)}
                        errorElement={<Error404 />}
                    />
                    {/* Push из модуля ревизий ведёт на /cash-audit — уводим на наш маршрут */}
                    <Route path="/cash-audit/*" element={<Navigate to="/audit" replace />} />
                </Routes>
            </Suspense>
        </CustomBrowserRouter>
    </React.StrictMode>
);

export default RoutesComponent;